<template>
  <details
    open
    :class="[
      $style['collapse'],
      { [$style['collapse--strong']]: strong },
      { [$style['collapse--border']]: border },
      { [$style['collapse--show']]: show },
    ]">
    <summary
      :class="$style['collapse__title']"
      tabindex="0"
      @click.prevent="toggle"
      @keydown.enter="toggle">
      <SvgIcon
        :class="[
          $style['collapse__icon']
        ]"
        name="System/arrow-right-s-line" />
      <span>{{ title }}</span>
    </summary>
    <div
      :class="[
        $style['collapse__content'],
        { [$style['collapse__content--with-icon']]: icon }
      ]">
      <slot />
    </div>
  </details>
</template>
<script setup>
const props = defineProps({
  title: {
    type: String,
    default: null
  },
  icon: {
    type: String,
    default: null
  },
  border: {
    type: Boolean,
    default: false
  },

  strong: {
    type: Boolean,
    default: false
  },
  defaultOpen: {
    type: [String, Array, Boolean, Number],
    default: false
  }
})

const show = ref(false)
const toggle = () => {
  show.value = !show.value
}
onMounted(() => {
  if (props.defaultOpen) {
    show.value = true
  }
})
</script>

<style lang="scss" module>
.collapse {
  border-top: 1px solid var(--grey-lighter);
  border-radius: var(--border-radius) var(--border-radius);
  display: flex;
  flex-direction: column;
  width: 100%;

  summary::-webkit-details-marker {
    display: none;
  }

  &__icon {
    width: calc(var(--spacing) * 3);
    height: calc(var(--spacing) * 3);
    text-align: center;
    line-height: 1;
    margin-right: var(--spacing);
    user-select: none;
    position: relative;
    flex-shrink: 0;
    transform: rotate(0);
    transition: transform var(--transition-time-slower) var(--transition-easing);

  }

  &__title {
    align-items: center;
    border-radius: var(--border-radius) var(--border-radius);
    cursor: pointer;
    font-size: var(--font-size);
    justify-content: flex-start;
    display: flex;
    width: 100%;
    line-height: var(--line-height);
    padding-left: var(--spacing);
    height: calc(var(--spacing ) * 6);
    transition: all var(--transition-time) var(--transition-easing);

    &__icon {
      height: calc(var(--spacing) * 3);
      margin: 0 calc(var(--spacing ) * 3);
    }

    &:active,
    &:hover {
      background-color: var(--grey-lightest);
    }

    &:focus-visible {
    box-shadow: var(--focus-visible-small);
  }
  }

  &__content {
    border-radius:0 0 var(--border-radius) var(--border-radius);
    max-height: 0;
    overflow: hidden;
    transition:  all var(--transition-time-slowest) var(--transition-easing);

    &--with-icon {
      padding: 0 calc(var(--spacing ) * 2);
    }
  }

  &--show {
    .collapse__content {
      max-height: 10000px;
    }

    &.collapse--border .collapse__content {
        border: 1px solid var(--grey-lighter);
        border-top-color: transparent;
    }

    &.collapse--border .collapse__title {
      border-bottom-left-radius:  0;
      border-bottom-right-radius:  0;
    }

    .collapse__icon {
        transform: rotate(90deg);
    }
  }

  &--strong {
    .collapse__title {
      font-weight: var(--font-weight-bold);
    }
  }

  &--border {
    border-top: 0;

    .collapse__title {
      border: 1px solid var(--grey-lighter);

    }

    .collapse__content {
      border: 1px solid transparent;

    }
  }
}

</style>
